class Progress {
    constructor (options = {}) {
        this.prevValue = 0;
        this.value = 0;
        this.waitingTime = 0;

        this.size = options.size && Number(options.size) || 100;
        this.processedSize = 0;
        this.leftSize = this.size;
        this.timeout = options.timeout || 60000;
        this.onsucceeded = options.onsucceeded;
        this.onerror = options.onerror;
        this.onupdated = options.onupdated;
        this.children = [];
        this.disposed = false;
        this.updateValue(0);
    }

    setSize (size = 100) {
        this.size = Number(size) || 100;
    }

    getValue () {
        return this.value;
    }

    addChild (child) {
        if (child instanceof Progress) {
            if (this.children.indexOf(child) === -1) {
                child.parent = this;
                this.children.push(child);
            }
        }
    }

    compute (value) {
        if (value) {
            this.processedSize = value / 100 * this.size;
        }
        let total = this.children.reduce((prev, next) => prev + next.size, this.size);
        let totalProcessed = this.children.reduce((prev, next) => prev + next.processedSize, this.processedSize);
        let parent = this.parent;
        while (parent) {
            total += this.parent.size;
            totalProcessed += this.parent.processedSize;
            parent = this.parent.parent;
        }
        return Math.round(totalProcessed / total * 1000) / 10;
    }

    updateValue (newValue) {
        if (this.disposed) return;
        if (newValue) {
            newValue = Number(newValue);
            if (newValue > 100) return;
            if (newValue < 0) return;
        }
        this.waitingTime = 0;
        this.fakeTime = Date.now();
        this.prevValue = this.value;
        this.value = this.compute(newValue);
        if (!this.parent) {
            console.log('******** true progress ******* ', this.value);
        }
        this.triggerUpdate();
        let parent = this.parent;
        while (parent) {
            parent.updateValue();
            parent = parent.parent;
        }
        if (this.value < 100) {
            this.startFake();
        } else {
            this.triggerSucceeded();
        }
    }

    startFake () {
        if (this.parent) return;
        if (this.disposed) return;
        this.stopFake();
        this.fakeTimeId = setInterval(() => {
            this.updateFakeValue();
        }, 1000);
    }

    stopFake () {
        clearInterval(this.fakeTimeId);
    }

    updateFakeValue () {
        if (this.disposed) return;
        if (!navigator.onLine) {
            this.triggerOfflineError();
            return;
        }
        this.waitingTime = this.fakeTime ? Date.now() - this.fakeTime : 0;
        this.value += 0.1;
        console.log('*** fake progress *** ', this.value, '*** waiting time *** ', this.waitingTime);
        this.triggerUpdate(this.value);
        if (this.waitingTime >= this.timeout) {
            this.triggerTimeoutError();
        }
    }

    triggerUpdate (value = this.value) {
        if (this.disposed) return;
        if (value > this.prevValue && typeof this.onupdated === 'function') {
            value = Math.round(value * 10) / 10;
            this.onupdated(value);
        }
    }

    triggerTimeoutError () {
        this.triggerError(new Error('Timeout: waiting time over ' + this.waitingTime));
    }

    triggerError (error) {
        if (typeof this.onerror === 'function') {
            this.onerror(error);
        }
        let parent = this.parent;
        while (parent) {
            parent.triggerError(error);
            parent = parent.parent;
        }
        this.dispose();
    }

    triggerOfflineError () {
        this.triggerError(new Error('Offline: not connected to the Internet '));
    }

    triggerSucceeded () {
        if (typeof this.onsucceeded === 'function') {
            this.onsucceeded();
        }
        this.dispose();
    }

    dispose () {
        this.disposed = true;
        this.prevValue = 0;
        this.value = 0;
        this.fake = 0;
        this.waitingTime = 0;
        this.onsucceeded = null;
        this.onerror = null;
        this.onupdated = null;
        this.parent = null;
        this.stopFake();
        this.children.forEach(child => {
            child.dispose();
        });
        this.children = [];
    }
}

export default Progress;